module.exports = __webpack_public_path__ + "static/media/icon9.7b86519f.png";